import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { triggersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation RemoveTriggers($ids: [Int]) {
    removeTriggers(ids: $ids)
  }
`

export const useRemoveTriggers = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Triggers'], client: triggersClient })
  const notify = useNotification()
  const modal = useAlert()
  const closeModal = useCloseModal()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) notify.error({ title: t('errorDelete') })
    })
  }

  return [handleRequest, state]
}
